import React from 'react';
import { Phone, Star, Zap, Shield, Award, Users, CheckCircle2 } from 'lucide-react';
import { Card, CardContent } from '../ui/card';

const reasons = [
  { icon: <Zap className="w-8 h-8" />, title: 'Same-Day Service', desc: 'Emergency repairs handled fast. We understand downtime costs money.', color: 'from-yellow-400 to-orange-500' },
  { icon: <Award className="w-8 h-8" />, title: 'Expert Fault Finding', desc: 'No guessing. Professional diagnostics save you time and money.', color: 'from-[#0066FF] to-[#00D9FF]' },
  { icon: <Shield className="w-8 h-8" />, title: 'Reliable & On-Time', desc: 'We show up when promised. Every time. No surprises.', color: 'from-blue-500 to-indigo-500' },
  { icon: <Users className="w-8 h-8" />, title: 'Trusted by 100+ Clients', desc: 'From homeowners to hotels – clients come back and refer us.', color: 'from-green-400 to-emerald-500' },
  { icon: <CheckCircle2 className="w-8 h-8" />, title: 'High-Quality Workmanship', desc: 'Done right the first time. We stand behind our work.', color: 'from-purple-500 to-pink-500' },
  { icon: <Phone className="w-8 h-8" />, title: 'Transparent Communication', desc: 'Clear quotes. No hidden fees. You always know what to expect.', color: 'from-red-500 to-rose-500' },
];

export const WhyChooseUs = () => {
  return (
    <section data-testid="why-choose-section" className="py-20 bg-[#111640]">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <span className="inline-block bg-[#0066FF]/20 text-[#00D9FF] px-5 py-2 rounded-full text-sm font-bold uppercase tracking-wider mb-4">
            Why Chill Point
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Why Ballito Trusts Chill Point
          </h2>
          <p className="text-base md:text-lg text-gray-400 max-w-2xl mx-auto">
            Fast response, expert solutions, and service you can count on
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {reasons.map((item, i) => (
            <Card key={i} className="bg-white/5 border border-white/10 hover:border-[#00D9FF]/20 hover:bg-white/[0.08] transition-all duration-300 transform hover:-translate-y-1 group">
              <CardContent className="p-8 text-center">
                <div className={`w-14 h-14 bg-gradient-to-br ${item.color} rounded-2xl flex items-center justify-center mx-auto mb-4 text-white shadow-lg group-hover:scale-110 transition-transform`}>
                  {item.icon}
                </div>
                <h3 className="text-lg font-bold text-white mb-3">{item.title}</h3>
                <p className="text-gray-400 leading-relaxed text-sm">{item.desc}</p>
              </CardContent>
            </Card>
          ))}
        </div>

        <div className="text-center mt-12">
          <div className="inline-flex items-center space-x-3 bg-white/5 border border-white/10 px-8 py-4 rounded-full">
            <Star className="w-5 h-5 fill-yellow-400 text-yellow-400" />
            <span className="text-white font-bold text-sm md:text-base">5.0 Star Rating &middot; 100% Customer Satisfaction</span>
          </div>
        </div>
      </div>
    </section>
  );
};
